var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1588 14.5799L19.677 18.0981C20.1031 18.5243 20.1057 19.2337 19.6697 19.6697C19.2307 20.1088 18.5301 20.109 18.0981 19.677L14.5799 16.1588C13.4849 16.9386 12.1453 17.3972 10.6986 17.3972C6.99906 17.3972 4 14.3981 4 10.6986C4 6.99906 6.99906 4 10.6986 4C14.3981 4 17.3972 6.99906 17.3972 10.6986C17.3972 12.1453 16.9386 13.4849 16.1588 14.5799ZM10.6986 15.7225C13.4732 15.7225 15.7225 13.4732 15.7225 10.6986C15.7225 7.92395 13.4732 5.67465 10.6986 5.67465C7.92394 5.67465 5.67465 7.92395 5.67465 10.6986C5.67465 13.4732 7.92394 15.7225 10.6986 15.7225Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.fc7d7a62.svg";
export { ForwardRef as ReactComponent };